// @ts-nocheck
export { default } from './ScrollTopFAB';
